export default __webpack_public_path__ + "static/collect-email-8c6e97cb0e657fa065b22f1d0404591c.png";